import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4661 1.21183C10.7836 0.977892 11.2164 0.977895 11.5339 1.21183L20.5774 7.8755C21.2768 8.39086 20.9123 9.50005 20.0435 9.50005H20V16.5H21V18H1V16.5H2V9.50005H1.95642C1.08764 9.50005 0.723127 8.39086 1.42254 7.8755L10.4661 1.21183ZM11 2.68167L3.78217 8.00005H18.2178L11 2.68167ZM3.5 16.5H6V9.50005H3.5V16.5ZM7.5 16.5H10.25V9.50005H7.5V16.5ZM11.75 16.5H14.5V9.50005H11.75V16.5ZM16 16.5H18.5V9.50005H16V16.5Z"
    />
    <path d="M1 21V19.5H21V21H1Z" />
  </svg>
);
